import { render, staticRenderFns } from "./NoSideBarMain.vue?vue&type=template&id=587c9175&"
import script from "./NoSideBarMain.vue?vue&type=script&lang=js&"
export * from "./NoSideBarMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports